import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  List,
  ListItemButton,
  ListItemText,
  Paper,
} from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";
import { getData } from "../../Webservice/Webservice";

function Policies() {
  const [policies, setPolicies] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    fetchPolicies();
  }, []);

  const fetchPolicies = async () => {
    try {
      const res = await getData("policy/privacy");
      if (res && res.policies) {
        setPolicies(res.policies);
        if (res.policies.length > 0) {
          setSelected(res.policies[0].title);
        }
      }
    } catch (error) {
      console.error("Error fetching policies:", error);
    }
  };

  const selectedPolicy = policies.find((p) => p.title === selected);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        gap: { xs: 3, md: 6 },
        px: { xs: 2, sm: 4, md: 8 },
        py: { xs: 4, md: 6 },
        minHeight: "100vh",
      }}
    >
      {/* Sidebar */}
      <Paper
        elevation={3}
        sx={{
          width: { xs: "100%", md: "25%" },
          overflow: "hidden",
          bgcolor: "white",
          border: "1px solid black",
        }}
      >
        <Box sx={{ p: 3, borderBottom: "1px solid #eee" }}>
          <Typography
            variant="h4"
            sx={{
              fontSize: { xs: "26px", sm: "32px" },
              fontWeight: 700,
              color: "#222",
              textAlign: { xs: "center", md: "left" },
            }}
          >
            Policies
          </Typography>
        </Box>

        <List sx={{ py: 0 }}>
          {policies.map((policy) => (
            <ListItemButton
              key={policy._id}
              onClick={() => setSelected(policy.title)}
              sx={{
                transition: "all 0.3s ease",
                bgcolor: selected === policy.title ? "#dad2d259" : "transparent",
                "&:hover": { bgcolor: "#bbb8b859" },
                px: 3,
              }}
            >
              <ListItemText
                primary={policy.title}
                primaryTypographyProps={{
                  fontWeight: selected === policy.title ? 600 : 400,
                  color: selected === policy.title ? "#000000ff" : "#333",
                  fontSize: "15px",
                  textTransform: "capitalize",
                }}
              />
            </ListItemButton>
          ))}
        </List>
      </Paper>

      {/* Content */}
      <Paper
        elevation={3}
        sx={{
          flex: 1,
          p: { xs: 3, md: 5 },
          bgcolor: "white",
          display: "flex",
          flexDirection: "column",
          border: "1px solid black",
          textAlign: "left",
        }}
      >
        <AnimatePresence mode="wait">
          {selectedPolicy && (
            <motion.div
              key={selected}
              initial={{ opacity: 0, y: 15 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -15 }}
              transition={{ duration: 0.3 }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 600,
                  mb: 2,
                  color: "#1a1a1a",
                  fontSize: { xs: "20px", md: "24px" },
                  textTransform: "capitalize",
                  textAlign: "center",
                }}
              >
                {selected}
              </Typography>
              <Box
                sx={{
                  color: "#555",
                  lineHeight: 1.8,
                  fontSize: { xs: "14px", md: "16px" },
                  "& ol, & ul": { pl: 3 },
                  "& li": { mb: 1 },
                }}
                dangerouslySetInnerHTML={{ __html: selectedPolicy.contentHtml }}
              />
            </motion.div>
          )}
        </AnimatePresence>
      </Paper>
    </Box>
  );
}

export default Policies;
